let selectedPaket = ""

export let DATSearchPaket = { selectedPaket }
